import * as ActionTypes from '../ActionTypes'
import * as RestURI from '../../shared/RestURI';

import {awsConfig} from '../../shared/config';
import {addToBucket} from './ActionCreatorsBucket';
import * as AuthC from '../../utils/auth/AuthCognito';
import * as RestCallHelper from '../../utils/network/RestCallHelper'


const authzLoading = (loadCriteria) => ({
    type: ActionTypes.AUTHORIZATIONS_LOADING,
    payload: loadCriteria
});

const authzFailed = (errmess) => ({
    type: ActionTypes.AUTHORIZATIONS_FAILED,
    payload: errmess
});

const addAuthorizations = (authorizations) => ({
    type: ActionTypes.ADD_AUTHORIZATIONS,
    payload: authorizations
});

const addAuthz = (authorization) => ({
    type: ActionTypes.ADD_AUTHZ,
    payload: authorization
});
  
const updateAuthz = (authorization) => ({
    type: ActionTypes.UPDATE_AUTHZ,
    payload: authorization
});
  

export const fetchAuthzs = (employeeId) => (dispatch) => {
    dispatch(authzLoading({employeeId: employeeId}));

    const urlParams = new URLSearchParams({ employeeId: employeeId });
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.AUTHZS}?${urlParams}`);

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json())
        .then(auths => dispatch(addAuthorizations(auths)))
        .catch(error => {
            dispatch(authzFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Autorizatiilor" } }));
        });
}
  
  
export const postAuthISCIR = (authorization, reminder) => (dispatch) => {
    var body = {authorization: authorization};
    if(reminder) {
        reminder.createDate = new Date().toISOString();
        body.reminder = reminder;
    }

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.AUTHZS_ISCIR, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        // .then(authorization => dispatch(addAuthAndGenReminder(authorization)))
        .then(authz => dispatch(addAuthz(authz.authorization)))
        .then(authAction => dispatch(addToBucket({ mostRecentAuthzId: authAction.payload.id, snackbar: { open: true, severity: "success", message: "Autorizatie ISCIR creata cu succes" } })))
        .catch(error => {
            dispatch(authzFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul crearii Autorizatiei ISCIR" } }));
        });
}


export const patchAuthISCIR = (authorization, reminder) => (dispatch) => {
    var body = {authorization: authorization};
    if(reminder) {
        reminder.updateDate = new Date().toISOString();
        body.reminder = reminder;
    }

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.AUTHZS_ISCIR + `/${authorization.id}`, {
        method: "PATCH",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(authz => dispatch(updateAuthz(authz.authorization)))
        // .then(auth => dispatch(updateAuthAndRegenReminder(auth)))
        // .then(authAction => dispatch(addSnackbarToBucket( [{ open: true, severity: "success", message: "Autorizatie ISCIR salvata cu succes" }] )))
        .then(authAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Autorizatie ISCIR salvata cu succes" } })))
        .catch(error => {
            dispatch(authzFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul salvarii Autorizatiei ISCIR" } }));
        });
}


export const patchAuthzsStampDate = (employerId, updatedAuthzArray, notUpdatedAuthzArray, stampDate) => (dispatch) => {
    const body = {
        employerId: employerId,
        updatedAuthzs: updatedAuthzArray,
        notUpdatedAuthzs: notUpdatedAuthzArray,
        stampDate: stampDate
    };

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.AUTHZS_ISCIR, {
        method: "PATCH",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        // .then(authz => dispatch(updateAuthISCIR(authz.authorization)))
        // .then(auth => dispatch(updateAuthAndRegenReminder(auth)))
        // .then(authAction => dispatch(addSnackbarToBucket( [{ open: true, severity: "success", message: "Autorizatie ISCIR salvata cu succes" }] )))
        .then(authAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Viza Talon pentru Autorizatiile ISCIR actualizate cu succes" } })))
        .catch(error => {
            dispatch(authzFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul actualizarii Viza Talon pentru Autorizatiile ISCIR" } }));
        });
}


export const postAuthzIscirImage = (fileName, imageBase64, employerId, employeeId, authzId, imageType) => (dispatch) => {

    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.AUTHZS_ISCIR_IMAGE}`);

    const bodyContent = {
        fileName: fileName,
        imageBase64: imageBase64,
        employerId: employerId,
        employeeId: employeeId,
        authzId: authzId,
        imageType: imageType
    };

    return RestCallHelper.postAsJson(url, bodyContent)
        .then(authz => dispatch(updateAuthz(authz)))
        .then(authAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Imagine Autorizatie ISCIR salvata cu succes" } })))
        .catch(error => {
            dispatch(authzFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul salvarii Imaginii Autorizatiei ISCIR" } }));
        });
}


 ///////////////////////////////////
 
   
  
export const postAuthzInternal = (authorization, reminder) => (dispatch) => {
    var body = {authorization: authorization};
    if(reminder) {
        body.reminder = reminder;
    }

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.AUTHZS_INTERNAL, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        // .then(authorization => dispatch(addAuthAndGenReminder(authorization)))
        .then(authz => dispatch(addAuthz(authz.authorization)))
        .then(authAction => dispatch(addToBucket({ mostRecentAuthzId: authAction.payload.id, snackbar: { open: true, severity: "success", message: "Autorizatie Interna creata cu succes" } })))
        .catch(error => {
            dispatch(authzFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul crearii Autorizatiei Interne" } }));
        });
}


export const patchAuthzInternal = (authorization, reminder) => (dispatch) => {
    var body = {authorization: authorization};
    if(reminder) {
        body.reminder = reminder;
    }

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.AUTHZS_INTERNAL + `/${authorization.id}`, {
        method: "PATCH",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(authz => dispatch(updateAuthz(authz.authorization)))
        // .then(auth => dispatch(updateAuthAndRegenReminder(auth)))
        // .then(authAction => dispatch(addSnackbarToBucket( [{ open: true, severity: "success", message: "Autorizatie ISCIR salvata cu succes" }] )))
        .then(authAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Autorizatie Interna salvata cu succes" } })))
        .catch(error => {
            dispatch(authzFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul salvarii Autorizatiei Interne" } }));
        });
}


export const patchAuthzsCertDate = (taskId, clientId, employerId, updatedAuthzArray, notUpdatedAuthzArray, certificateDate) => (dispatch) => {
    const body = {
        taskId: taskId,
        clientId: clientId, 
        employerId: employerId,
        updatedAuthzs: updatedAuthzArray,
        notUpdatedAuthzs: notUpdatedAuthzArray,
        certificateDate: certificateDate
    };

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.AUTHZS_INTERNAL, {
        method: "PATCH",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(authAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Data Adeverinta pentru Autorizatiile Interne actualizate cu succes" } })))
        .catch(error => {
            dispatch(authzFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul actualizarii Data Adeverinta pentru Autorizatiile Interne" } }));
        });
}


export const postAuthzInternalCert = (fileName, imageBase64, employerId, employeeId, authzId) => (dispatch) => {

    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.AUTHZS_INTERNAL_CERT}`);

    const bodyContent = {
        fileName: fileName,
        imageBase64: imageBase64,
        employerId: employerId,
        employeeId: employeeId,
        authzId: authzId
    };

    return RestCallHelper.postAsJson(url, bodyContent)
        .then(authz => dispatch(updateAuthz(authz)))
        .then(authAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Certificat Autorizatie Interna salvat cu succes" } })))
        .catch(error => {
            dispatch(authzFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul salvarii certificatului" } }));
        });
}
